/* import __COLOCATED_TEMPLATE__ from './copilot-summary.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type IntlService from 'ember-intl/services/intl';

export default class StandaloneCopilotSummaryCard extends Component {
  @service declare finStandaloneService: FinStandaloneService;
  @service declare appService: AppService;
  @service declare intl: IntlService;

  get copilotSeatCount() {
    return this.appService.app.humanAdminsWithCopilotSeat.length;
  }

  get zendeskConfiguration() {
    return this.finStandaloneService.zendeskConfig;
  }

  get title() {
    return this.intl.t('standalone.channels.overview.cards.zendesk-copilot.title');
  }

  get description() {
    return this.intl.t('standalone.channels.overview.cards.zendesk-copilot.live-description');
  }

  get manageRoute() {
    return 'apps.app.standalone.deploy.zendesk.copilot';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Overview::CopilotSummary': typeof StandaloneCopilotSummaryCard;
    'standalone/deploy/overview/copilot-summary': typeof StandaloneCopilotSummaryCard;
  }
}
